<template>
  <div class="main-content-container overflow-hidden">
    <CreateItem />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import CreateItem from "@/components/Pages/Management/Item/CreateItem.vue";

export default defineComponent({
  name: "CreateItemPage",
  components: {
    CreateItem,
  },
});
</script>
